import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import type { FC, ReactNode } from 'react';

interface TableProps {
    id: string;
    children?: ReactNode;
    className?: string;
    padding?:'checkbox'| 'none'| 'normal';
    size?: 'medium'| 'small'
    stickyHeader?:boolean;
    tableContainerClassName?:string;
}

const CustomTable: FC<TableProps> = ({
  id,
  children,
  padding = 'normal',
  size = 'medium' ,
  stickyHeader= false,
  className,
  tableContainerClassName,
  ...rest
}) => {

  return (
    <TableContainer id={`table-container-${id}`} className={tableContainerClassName}>
      <Table
        id={id}
        padding = {padding}
        size = {size}
        stickyHeader= {stickyHeader}
        className= {className}
        {...rest}
      >
        {children}
      </Table>
    </TableContainer>
  );
}

export default CustomTable;